<div class="card dados-variavel-container">
    <div class="flex align-items-center justify-content-between mb-3 dados-variavel-header">
        <div>
            <h5 class="p-m-0">Dados de Variável</h5>
            <small class="p-text-secondary">Gerencie os dados coletados das variáveis das estações.</small>
        </div>
        <div>
            <button pButton pRipple type="button" label="Importar em Lote" icon="pi pi-upload"
                class="p-button-success" (click)="abrirWizardImportacao()">
            </button>
        </div>
    </div>

    <!-- Filtros -->
    <div class="p-card mb-3">
        <div class="p-card-body">
            <div class="p-fluid grid">
                <div class="field field-label-top col-12 md:col-3">
                    <label for="estacao">Estação *</label>
                    <p-dropdown inputId="estacao" appendTo="body" [options]="dropDownEstacoes"
                        [(ngModel)]="estacaoSelecionada" [filter]="true" filterLocale="pt-BR"
                        filterPlaceholder="Pesquisar estação" [showClear]="true" placeholder="Selecione">
                    </p-dropdown>
                </div>

                <div class="field field-label-top col-12 md:col-3">
                    <label for="tipo_variavel">Tipo de Variável</label>
                    <p-dropdown inputId="tipo_variavel" appendTo="body" [options]="dropDownTipoVariavel"
                        [(ngModel)]="tipoVariavelSelecionado" [filter]="true"
                        filterPlaceholder="Pesquisar tipo" [showClear]="true" placeholder="Selecione">
                    </p-dropdown>
                </div>

                <div class="field field-label-top col-12 md:col-2">
                    <label for="data_inicial">Data Inicial *</label>
                    <p-datepicker inputId="data_inicial" [(ngModel)]="dataInicial"
                        dateFormat="dd/mm/yy" [showIcon]="true"
                        [maxDate]="dataFinal" placeholder="Data Inicial" styleClass="w-full">
                    </p-datepicker>
                </div>

                <div class="field field-label-top col-12 md:col-2">
                    <label for="data_final">Data Final *</label>
                    <p-datepicker inputId="data_final" [(ngModel)]="dataFinal"
                        dateFormat="dd/mm/yy" [showIcon]="true"
                        [minDate]="dataInicial" placeholder="Data Final" styleClass="w-full">
                    </p-datepicker>
                </div>

                <div class="field col-12 md:col-2 flex align-items-end">
                    <button pButton pRipple type="button" label="Filtrar" icon="pi pi-search"
                        class="p-button-primary" (click)="filtrar()" [loading]="loading">
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Grid -->
    <div class="dados-variavel-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id" [loading]="loading"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['tipoVariavel.tipo_variavel', 'data_hora_dado', 'valor']"
            [scrollable]="true" [scrollHeight]="scrollHeight">

        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between p-flex-wrap">
                <div class="flex align-items-center p-flex-wrap">
                    <h5 class="p-m-0" style="margin-right: 30px;">Dados de Variável</h5>
                    <button pButton pRipple type="button" label="Novo Dado"
                        icon="pi pi-plus" class="p-button-success p-button-sm mr-2"
                        [disabled]="!dadosFiltrados"
                        (click)="openNew()">
                    </button>
                    <button pButton pRipple type="button" label="Forçar Integração"
                        icon="pi pi-refresh" class="p-button-info p-button-sm"
                        [disabled]="!dadosFiltrados || loadingIntegracao"
                        [loading]="loadingIntegracao"
                        (click)="forcarIntegracao()"
                        pTooltip="Forçar integração dos dados filtrados" tooltipPosition="top">
                    </button>
                    <button pButton pRipple type="button" label="Reprocessar Coleta"
                        icon="pi pi-sync" class="p-button-warning p-button-sm ml-2"
                        [disabled]="!estacaoSelecionada || !dataInicial || loadingReprocessamento"
                        [loading]="loadingReprocessamento"
                        (click)="reprocessarOnixsat()"
                        pTooltip="Reprocessar dados da estação a partir da data inicial" tooltipPosition="top">
                    </button>
                </div>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>Tipo de Variável</th>
                <th>Data/Hora</th>
                <th>Valor</th>
                <th style="width: 140px; text-align: center;">Ações</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
            <tr>
                <td>
                    <span class="p-column-title negrito">Tipo de Variável: </span>
                    {{getTipoVariavelNome(item)}}
                </td>
                <td>
                    <span class="p-column-title negrito">Data/Hora: </span>
                    {{formatarDataHora(item.data_hora_dado)}}
                </td>
                <td>
                    <span class="p-column-title negrito">Valor: </span>
                    {{item.valor}}
                </td>
                <td style="text-align: center;">
                    <span class="p-column-title negrito">Ações: </span>
                    <button pButton pRipple type="button" icon="pi pi-pencil"
                        class="p-button-rounded p-button-primary p-button-sm"
                        pTooltip="Editar" tooltipPosition="top"
                        [disabled]="!dadosFiltrados || !direitoEditar"
                        (click)="edit(item)">
                    </button>
                    <button pButton pRipple type="button" icon="pi pi-trash"
                        class="p-button-rounded p-button-danger p-button-sm ml-2"
                        pTooltip="Excluir" tooltipPosition="top"
                        [disabled]="!dadosFiltrados || !direitoExcluir"
                        (click)="delete(item)">
                    </button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" style="text-align: center;">
                    Nenhum dado encontrado. Aplique os filtros para buscar dados.
                </td>
            </tr>
        </ng-template>
        </p-table>
    </div>
</div>

<!-- Modal de Edição/Inserção -->
<p-dialog [header]="isEditMode ? 'Editar Dado de Variável' : 'Novo Dado de Variável'" 
    [(visible)]="displayModal" [modal]="true"
    [style]="{width: '50vw', maxWidth: '600px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true" (onHide)="closeModal()">

    <form [formGroup]="form" class="p-fluid grid">
        <div class="field field-label-top col-12">
            <label for="tipo_variavel_modal">Tipo de Variável *</label>
            <p-dropdown inputId="tipo_variavel_modal" appendTo="body" [options]="dropDownTipoVariavel"
                formControlName="tipo_variavel_id" [filter]="true"
                filterPlaceholder="Pesquisar tipo" [showClear]="true" placeholder="Selecione"
                [disabled]="isEditMode">
            </p-dropdown>
            <small class="p-error" *ngIf="form.get('tipo_variavel_id')?.invalid && form.get('tipo_variavel_id')?.touched">
                Campo obrigatório
            </small>
        </div>

        <div class="field field-label-top col-12">
            <label for="data_hora_dado">Data/Hora *</label>
            <p-datepicker inputId="data_hora_dado" formControlName="data_hora_dado"
                dateFormat="dd/mm/yy" [showTime]="true" [showIcon]="true"
                [hourFormat]="'24'" appendTo="body"
                [disabled]="isEditMode"
                [minDate]="!isEditMode && dataInicial ? dataInicial : null"
                [maxDate]="!isEditMode && dataFinal ? dataFinal : null"
                styleClass="w-full">
            </p-datepicker>
            <small class="p-error" *ngIf="form.get('data_hora_dado')?.invalid && form.get('data_hora_dado')?.touched">
                Campo obrigatório
            </small>
            <small class="p-text-secondary" *ngIf="!isEditMode && dataInicial && dataFinal">
                Período permitido: {{formatarData(dataInicial)}} a {{formatarData(dataFinal)}}
            </small>
        </div>

        <div class="field field-label-top col-12">
            <label for="valor">Valor *</label>
            <p-inputNumber inputId="valor" formControlName="valor"
                mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="10"
                [showButtons]="false" placeholder="0.00" styleClass="w-full">
            </p-inputNumber>
            <small class="p-error" *ngIf="form.get('valor')?.invalid && form.get('valor')?.touched">
                Campo obrigatório e deve ser um número válido
            </small>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="closeModal()"></button>
        <button pButton pRipple type="button" label="Salvar" icon="pi pi-check"
            [disabled]="loading || form.invalid" (click)="save()"
            class="p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '35px', height: '35px'}"
            styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

<!-- Modal Wizard de Importação em Lote -->
<p-dialog header="Importar Dados em Lote" [(visible)]="mostrarWizardImportacao" [modal]="true"
    [style]="{width: '80vw', maxWidth: '1200px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="true" (onHide)="resetarWizard()">

    <!-- Passo 1: Upload e Seleção de Estação -->
    <div *ngIf="passoWizard === 1" class="p-fluid grid">
        <div class="field col-12">
            <label>Selecione a Estação *</label>
            <p-dropdown inputId="estacaoWizard" appendTo="body" [options]="dropDownEstacoes"
                [(ngModel)]="estacaoWizard" [filter]="true" filterLocale="pt-BR"
                filterPlaceholder="Pesquisar estação" [showClear]="true" placeholder="Selecione">
            </p-dropdown>
        </div>

        <div class="field col-12">
            <label>Selecione o Arquivo (CSV, XLSX ou XLS) *</label>
            <p-fileUpload #fileUpload name="arquivo" [customUpload]="true"
                [showUploadButton]="false" [showCancelButton]="false" [multiple]="false"
                accept=".csv,.xlsx,.xls" (onSelect)="onFileSelect($event)" 
                [auto]="false" [maxFileSize]="10000000"
                chooseLabel="Selecionar Arquivo">
                <ng-template pTemplate="content">
                    <ul *ngIf="arquivoSelecionado" class="p-m-0 mt-2">
                        <li class="flex align-items-center">
                            <i class="pi pi-file mr-2"></i>
                            <span>{{arquivoSelecionado.name}} ({{(arquivoSelecionado.size / 1024).toFixed(2)}} KB)</span>
                            <button pButton pRipple type="button" 
                                icon="pi pi-times" 
                                class="p-button-text p-button-rounded p-button-danger p-button-sm ml-2"
                                (click)="arquivoSelecionado = null; fileUpload.clear()"
                                pTooltip="Remover arquivo">
                            </button>
                        </li>
                    </ul>
                </ng-template>
            </p-fileUpload>
            <p-progressSpinner *ngIf="processandoArquivo" [style]="{width: '35px', height: '35px'}"
                styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
        </div>

        <div class="col-12 flex justify-content-end">
            <button pButton pRipple type="button" label="Próximo" icon="pi pi-arrow-right"
                [disabled]="!arquivoSelecionado || !estacaoWizard || processandoArquivo"
                (click)="irParaMapeamento()" class="p-button-primary">
            </button>
        </div>
    </div>

    <!-- Passo 2: Mapeamento de Colunas -->
    <div *ngIf="passoWizard === 2" class="p-fluid grid">
        <div class="col-12">
            <h5>Mapear Colunas do Arquivo para Tipos de Variável</h5>
            <p class="p-text-secondary">Selecione o tipo de variável correspondente a cada coluna de valor do arquivo.</p>
            <p class="p-text-secondary"><strong>Coluna de Data/Hora detectada:</strong> {{colunaDataHora || 'Não detectada'}}</p>
        </div>

        <div class="col-12" *ngFor="let coluna of colunasValor">
            <div class="field grid">
                <label class="col-12 md:col-3">{{coluna}}</label>
                <div class="col-12 md:col-9">
                    <p-dropdown [options]="getOpcoesTipoVariavel(coluna)" appendTo="body"
                        [(ngModel)]="mapeamentoColunas[coluna]" [filter]="true"
                        filterPlaceholder="Selecione tipo" placeholder="Selecione o tipo de variável">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <div class="col-12 flex justify-content-between">
            <button pButton pRipple type="button" label="Voltar" icon="pi pi-arrow-left"
                (click)="passoWizard = 1" class="p-button-secondary">
            </button>
            <button pButton pRipple type="button" label="Gerar Preview" icon="pi pi-eye"
                [disabled]="!mapeamentoValido()"
                (click)="gerarPreview()" class="p-button-primary">
            </button>
        </div>
    </div>

    <!-- Passo 3: Preview -->
    <div *ngIf="passoWizard === 3" class="p-fluid">
        <div class="col-12 mb-3">
            <h5>Preview dos Dados</h5>
            <p class="p-text-secondary">
                {{dadosSelecionados().length}} registro(s) para importar
                <span *ngIf="!somenteNovos && getTotalRegistrosExistentes() > 0"> | {{getTotalRegistrosExistentes()}} medição(ões) correspondem a registros existentes</span>
                <span *ngIf="somenteNovos"> | {{getTotalRegistrosExistentes()}} medição(ões) com registros existentes ignoradas</span>
            </p>
            <label class="preview-opcao">
                <input type="checkbox" [(ngModel)]="somenteNovos" (ngModelChange)="atualizarPreview()" />
                Mostrar e importar somente registros que não existem
            </label>
        </div>

        <div class="col-12 preview-legenda" aria-label="Legenda da comparação">
            <span><i class="legenda-cor preview-igual"></i> Valor igual ao atual</span>
            <span><i class="legenda-cor preview-diferente"></i> Valor diferente do atual</span>
            <span><i class="legenda-cor legenda-novo"></i> Novo ou sem alteração</span>
        </div>
        <div class="col-12">
            <p-table [value]="previewLinhas" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[25, 50, 100]"
                [showCurrentPageReport]="true" currentPageReportTemplate="Linhas {first} a {last} de {totalRecords}"
                [scrollable]="true" scrollHeight="400px" styleClass="preview-comparacao">
                <ng-template pTemplate="header">
                    <tr><th rowspan="2" class="preview-data">Data/Hora</th>
                        <th *ngFor="let tipo of previewVariaveis" colspan="2" class="preview-tipo">{{getTipoVariavelNome(tipo)}}</th></tr>
                    <tr><ng-container *ngFor="let tipo of previewVariaveis"><th>Atual no banco</th><th>A importar</th></ng-container></tr>
                </ng-template>
                <ng-template pTemplate="body" let-linha>
                    <tr><td class="preview-data">{{formatarDataHora(linha.data_hora_dado)}}</td>
                        <ng-container *ngFor="let tipo of previewVariaveis">
                            <td [ngClass]="linha.valores[tipo]?.classe">{{linha.valores[tipo]?.atual ?? '—'}}</td>
                            <td [ngClass]="linha.valores[tipo]?.classe">{{linha.valores[tipo]?.importado ?? '—'}}</td>
                        </ng-container></tr>
                </ng-template>
            </p-table>
        </div>

        <div class="col-12 flex justify-content-between mt-3">
            <button pButton pRipple type="button" label="Voltar" icon="pi pi-arrow-left"
                (click)="voltarParaMapeamento()" class="p-button-secondary">
            </button>
            <button pButton pRipple type="button" label="Importar" icon="pi pi-check"
                [disabled]="loading || dadosSelecionados().length === 0" (click)="importarEmLote()" class="p-button-success">
            </button>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-progressSpinner *ngIf="loading" [style]="{width: '35px', height: '35px'}"
            styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

<p-toast></p-toast>

